import {Injectable} from '@angular/core';
import {LoginHelper} from '../helpers';

import {AuthenticationService} from './index';
import {Bulletin} from "../_models/bulletin";
import {Load} from "../_decorators/loading.decorator";
import {HttpClient} from "@angular/common/http";
import {IndexConfigService} from "./index.config.service";

@Injectable()
export class BulletinService {
  constructor(public http: HttpClient,
              public authenticationService: AuthenticationService,
              public config: IndexConfigService) {
  }

  getById(id: number) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .get<any>(this.config.api + '/api/bulletins/bulletin/' + id + '')
      ;
  }

  getAll() {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .get<any>(this.config.api + '/api/bulletins/all/')
      ;
  }

  getForTenant() {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .get<any>(this.config.api + '/api/bulletins/tenant/')
      ;
  }

  @Load()
  update(id: number, bulletin: Bulletin) {

    const tenantName = bulletin.tenantName;
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .put(this.config.api + '/api/bulletins/update/' + id, bulletin)
      ;
  }

  @Load()
  create(bulletin: Bulletin) {

    const tenantName = bulletin.tenantName;
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .post<any>(this.config.api + '/api/bulletins/create/', bulletin)
      ;
  }

  @Load()
  delete(id: number) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .delete(this.config.api + '/api/bulletins/delete/' + id + '')
      ;
  }
}
